import React from "react";
import Link from "next/link";
import { Grid } from "@mui/material";
import { ReactSVG } from "react-svg";
import { getAssets } from "@unisearch/helpers";
import styles from "./top_section.module.scss";

export const IeltsPageTopSection = () => {
  return (
    <>
      <section className={styles.section_hero}>
        <div className="container">
          <Grid container spacing={{ xs: 3, sm: 3, md: 6 }} alignItems="center">
            <Grid item xs={12} sm={6} md={6}>
              <div className={styles.heading_wrapper}>
                <h1 className={styles.heading}>
                  Your Target{" "}
                  <span className={"mark color-orange"}>IELTS Score</span> is
                  Within Reach!
                </h1>
                <p className={styles.sub_text}>
                  Our highly-experienced IELTS trainers provide accurate
                  guidance to each student, equipping you with the skills,
                  strategies and resources you need to meet and surpass your
                  target scores with confidence.
                </p>

                <div className={styles.pricing_wrapper}>
                  <span className={styles.price_deleted}>₹ 10,000/</span>-
                  <span className={`color-orange`}> ₹499</span>
                  <div className={`${styles.price_text} color-orange`}>
                    Pay After Your First Class
                  </div>
                </div>

                <div className={styles.btn_wrapper}>
                  <a href={"#form"} className={`btn btn-secondary btn-xl`}>
                    Book Now
                  </a>
                </div>
              </div>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <div className="hero_image_wrapper">
                <img
                  src="/assets/images/elearning/lead/target-ielts-score.png"
                  alt="target ielts score"
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </section>
    </>
  );
};

export default IeltsPageTopSection;
